export const createCoopIcon = (iconName: string|null, filled: boolean = false, additionalClasses: string = '') =>
  iconName ? `<i class="${iconName}${filled ? '-filled' : ''} ${additionalClasses}" aria-label="Icon ${iconName}" aria-hidden="true"></i>` : '';
